import { Breadcrumbs } from "@components/Breadcrumbs"
import { Button } from "@components/Buttons"
import Footer from "@components/Footer"
import { Input } from "@components/FormFields"
import { SubLabel } from "@components/FormFields/Label/elements"
import { useIntl } from "@components/Intl"
import { navigation } from "@components/Intl/messages/navigation"
import { Box, Container } from "@components/Layout"
import { useNotificationsUpdate } from "@components/Notifications"
import { Gallery } from "@components/PhotoGallery"
import SEO from "@components/SEO"
import { Label, TitleLAlt } from "@components/Typography"
import imgix from "@config/imgix"
import { useAddGiftcardToCart } from "@lib/hooks/use-add-giftcard-to-cart"
import React, { useState } from "react"

export const GIFTCARD_ID = "9810000"

const Giftcard: React.FC = () => {
  const { messages } = useIntl()
  const { mutateAsync } = useAddGiftcardToCart()
  const { addNotification } = useNotificationsUpdate()
  const [value, setValue] = useState("20")
  const name = messages.navigation.giftcard.title

  let images = [
    imgix({
      key: GIFTCARD_ID,
      type: "article",
      args: {
        w: 750,
        h: 750,
      },
    }),
  ]
  let thumbnails = [
    imgix({
      key: GIFTCARD_ID,
      type: "article",
      args: {
        w: 75,
        h: 75,
      },
    }),
  ]

  const pathNl = navigation.nl.giftcard.url
  const pathEn = `/en${navigation.en.giftcard.url}`
  const breadcrumbs = [
    {
      href: messages.navigation.collection.url,
      as: messages.navigation.collection.url,
      label: messages.navigation.collection.title,
    },
    {
      href: "",
      as: "",
      label: name,
    },
  ]

  const onAddToCart = async () => {
    await mutateAsync({
      quantity: 1,
      amount: parseInt(value, 10),
    })

    addNotification({
      type: "success",
      text: `${name} ${messages.notifications.addedToCart}`,
    })
  }

  return (
    <>
      <SEO
        title="Giftcard"
        imageUrl={images[0] ? images[0] : ""}
        pathNl={pathNl}
        pathEn={pathEn}
      />
      <Container mt={["4rem", "5rem", "6rem"]} py={["3rem", "2rem", "4rem"]}>
        <Box display={["none", "block", "block"]}>
          <Breadcrumbs items={breadcrumbs} />
        </Box>
        <Box
          display="grid"
          gridColumnGap={3}
          gridTemplateColumns={["1fr", "1fr", "1fr 1fr"]}
          py={["4"]}
        >
          <Gallery images={images} thumbnails={thumbnails} />
          <Box
            maxWidth={["inherit", "inherit", "28rem"]}
            width="100%"
            ml={["inherit", "inherit", "auto"]}
            py="1rem"
          >
            <Box pb={["2rem", "4rem"]}>
              <TitleLAlt as="h1">{name}</TitleLAlt>
            </Box>

            <Box width={["100%", "20rem"]}>
              <Label>{messages.productDetail.giftcardValue}</Label>
              <SubLabel>{messages.productDetail.min20euro}</SubLabel>
              <Box
                display="grid"
                gridTemplateColumns={["1fr", "2fr 3fr"]}
                gridColumnGap="1rem"
              >
                <Input
                  value={value}
                  type="number"
                  onChange={(e) => setValue(e.target.value)}
                  min="20"
                  max="1000"
                  step="1"
                  style={{ height: "3.375rem" }}
                ></Input>
                <Button
                  variant="purple-border"
                  icon="add-to-bag"
                  title={messages.global.addToBag}
                  onClick={onAddToCart}
                >
                  {messages.global.addToBag}
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
      <Footer />
    </>
  )
}

export default Giftcard
